function awardMapping(data = {}, index) {

  return {
    key: index,
    id: data.STFA_ID ? data.STFA_ID : null,
    title: data.STFA_TITLE ? data.STFA_TITLE : null,
    show: data.STFA_SHOW ? data.STFA_SHOW : null,
    staffId: data.STAFF_ID ? data.STAFF_ID : null,    
  }
}
export default awardMapping
